import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Phone, MessageSquare } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white">
      {/* Emergency Helpline Banner */}
      <div className="bg-gradient-to-r from-teal-600 to-cyan-600 py-8">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <Heart className="h-10 w-10 mx-auto mb-3" />
          <h3 className="text-2xl font-bold mb-4">Need help</h3>
          <p className="text-lg mb-6">Contact the Alcohol Drug Helpline for free, confidential support</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
            <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
              <Phone className="h-8 w-8 mx-auto mb-2" />
              <p className="text-xl font-bold">0800 787 797</p>
              <p className="text-sm">Alcohol Drug Helpline - Free call anytime</p>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
              <MessageSquare className="h-8 w-8 mx-auto mb-2" />
              <p className="text-xl font-bold">8681</p>
              <p className="text-sm">Alcohol Drug Helpline - Free text anytime</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* About */}
          <div>
            <h4 className="text-xl font-bold mb-4 text-teal-400">About Cheers</h4>
            <p className="text-gray-300 leading-relaxed">
              A social change initiative creating a healthier, safer, and more responsible drinking culture in New Zealand.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-4 text-teal-400">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/balanced-lifestyle" className="text-gray-300 hover:text-teal-400 transition-colors">
                  Balanced Lifestyle
                </Link>
              </li>
              <li>
                <Link to="/pregnancy" className="text-gray-300 hover:text-teal-400 transition-colors">
                  Pregnancy & Alcohol
                </Link>
              </li>
              <li>
                <Link to="/standard-drinks" className="text-gray-300 hover:text-teal-400 transition-colors">
                  Standard Drinks
                </Link>
              </li>
              <li>
                <Link to="/tips" className="text-gray-300 hover:text-teal-400 transition-colors">
                  Tips for Drinking Better
                </Link>
              </li>
              <li>
                <Link to="/calculator" className="text-gray-300 hover:text-teal-400 transition-colors">
                  Calculator
                </Link>
              </li>
              <li>
                <Link to="/parents-teens" className="text-gray-300 hover:text-teal-400 transition-colors">
                  Parents & Teens
                </Link>
              </li>
              <li>
                <Link to="/smashed" className="text-gray-300 hover:text-teal-400 transition-colors">
                  SMASHED Project
                </Link>
              </li>
              <li>
                <Link to="/who-we-are" className="text-gray-300 hover:text-teal-400 transition-colors">
                  Who We Are
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-teal-400 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="max-w-6xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © The Tomorrow Project. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/privacy" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">
                Terms of Use
              </Link>
              <Link to="/contact" className="text-gray-400 hover:text-teal-400 text-sm transition-colors">
                Feedback
              </Link>
              <a
                href="https://app.emergent.sh/?utm_source=emergent-badge"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-teal-400 text-sm transition-colors"
                data-testid="footer-made-with-emergent-link"
              >
                Made with Emergent
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;